// @flow
import React from 'react'

import Loader from './master/components/Loader'

type State = {
  component: any
}

export const asyncComponent = (importComponent: Function) => {
  class AsyncComponent extends React.Component<null, State> {
    state = {
      component: null
    }

    async componentDidMount () {
      const { default: component } = await importComponent()

      this.setState({
        component
      })
    }

    render () {
      const C = this.state.component
      return C ? <C {...this.props} /> : <Loader />
    }
  }
  return AsyncComponent
}
